goog.provide('el8.uiwidget.FileUploader');

goog.require('el8.appservice.notifier');
goog.require('el8.model.AjaxQueue');
goog.require('el8.template.uiwidget.FileUploader');
goog.require('el8.uiwidget.Shade');

/**
 * A multi-file upload widget, which supports browsing for files and drag+drop.
 *
 * For example uses, see doc mgr (InboxFeed.js) as well as
 * patient photo uploading (uploadPtPhoto.js)
 *
 * @constructor
 */
el8.uiwidget.FileUploader = function(spec) {

    spec = spec || {};
    this._container = spec.container;
    this._uploadFormSelector = spec.uploadFormSelector || '.upload-file-content';

      //where the uploading queue will appear
    this._queueArea = spec.queueArea || null;
      //this area should get a "drop files her to upload" overlay
    this._droppableArea = spec.droppableArea || null;
      //this area is where we dragover to get the droppablearea to show up
    this._dragoverSelector = spec.dragoverSelector || 'body';

    this._url = spec.url || ''; //url to post file to
    this._customUploadFn = spec.customUploadFn || null; //if we want to, e.g., long poll (supersedes `url`)

    this._preUploadFn = spec.preUpload || null; //runs before the upload begins
    this._successFn = spec.success || null; //run after upload completes
    this._errorFn = spec.error || null; //run if upload fails

      //defaults to false: true if the uploader should only accept a file at a time
    this._singleFile = spec.singleFile || false;
      //message to show in notifier when files are received
    this._onUploadMessage = spec.onUploadMessage;
    this._onUploadFn = spec.onUploadFn;

    /* Indicates this an image upload, which assumes the entire image will be clickable
     * for uploading, and we don't need a button */
    this._isImageUpload = (spec.isImageUpload === true); // defaults to false

    /* Upload file button, disregarded when it's isImageUpload */
    this._buttonText = spec.buttonText || null;
    this._buttonClass = spec.buttonClass || null;

    /* Dimensions of the "clickable" area, disregarded when it's isImageUpload */
    this._inputHeight = spec.inputHeight || null;
    this._inputWidth = spec.inputWidth || null;

    /* Additional classes for customization */
    this._droppableZoneClass = spec.droppableZoneClass || null;
    this._imageHoverClass = spec.imageHoverClass || null;

    this._isDisabled = spec.isDisabled || false;

    this._init();
};

/**
 * Run this when you want the user to be able to select another file to upload
 * (clears the currently selected file)
 */
el8.uiwidget.FileUploader.prototype.resetUploadForm = function() {
    var that = this;
    $(this._uploadFormSelector, this._container).replaceWith(that.getUploadFormContents());
};
el8.uiwidget.FileUploader.prototype.getUploadFormContents = function() {
    var that = this;
    if (that._isImageUpload) {
        return el8.template.uiwidget.FileUploader.uploadFileForm({
            multiFile: !that._singleFile,
            inputWidth: that._inputWidth,
            inputHeight: that._inputHeight,
            isImage: true,
            isDisabled: that._isDisabled,
        });
    } else {
        return el8.template.uiwidget.FileUploader.uploadFileForm({
            multiFile: !that._singleFile,
            buttonText: that._buttonText,
            buttonClass: that._buttonClass,
            inputHeight: that._inputHeight,
            inputWidth: that._inputWidth,
            isImage: false,
            isDisabled: that._isDisabled,
        });
    }
};

/**
 * This UIWidget doesn't actually require display code, but it binds a drag
 * listener to the whole document, which needs to be unbound when the widget
 * is no longer visible.
 *
 * These functions could more accurately be called bindEvents and unbindEvents
 * but it is more conventional to keep those as internal functions
 */
el8.uiwidget.FileUploader.prototype.show = function() {
    this._bindEvents();
};
el8.uiwidget.FileUploader.prototype.hide = function() {
    this._unbindEvents();
    this._droppableOverlay.hide(); //it should always be hidden by here anyways...
};

el8.uiwidget.FileUploader.prototype._init = function() {
    var that = this;
    this._droppableOverlay = new el8.uiwidget.Shade();
    this._eventsBound = false;

    // Setup instance variables for delegation/undelegation
    var stopDefaultBehavior = function(evt) {
        evt.preventDefault();
        evt.stopPropagation();
    };
    /* The dragleave listener is dumb and fires everytime you move over a child element.
     * To prevent our overlay from giving the user seizures, we listen for the dragover
     * event (which fires repeatedly during a drag) and hide the overlay when it _stops_
     * firing */
    this._dragoverHandler = function(evt) {
        var dataTypes = evt.originalEvent.dataTransfer.types;
        if (dataTypes && !dataTypes.includes('Files')) return;

        if (!that._droppableTimeout) {
            //show the overlay for the first time
            that._droppableOverlay.show(that._droppableArea, {
                opacity: 0.9,
                zIndex: 10,
                container: that._container,
                content: function() {
                    return el8.template.uiwidget.FileUploader.droppableZone({
                        overlayClass: that._droppableZoneClass
                    });
                },
                scrollWithContainer: false
            });
        } else {
            //the overlay is already showing and we should reset the timer
            clearTimeout(that._droppableTimeout);
        }

        that._droppableTimeout = setTimeout(function() {
            that._droppableTimeout = null;
            that._droppableOverlay.hide();
        }, 100);
        stopDefaultBehavior(evt);
    };
    this._dropHandler = function(evt) {
        that._droppableOverlay.hide();
        var files = evt.originalEvent.dataTransfer.files;
        if (that._singleFile && files.length > 1) {
            files = [files[0]]; //unlike form upload, need to manually enforce _singleFile
        }
        that._doUpload(evt.originalEvent.dataTransfer.files);
        stopDefaultBehavior(evt);
    };
    this._inputChangeHandler = function(evt) {
        var files = evt.target.files;
        that._doUpload(files);
        stopDefaultBehavior(evt);
    };

    /* If we have an img, we insert a div that will show upon hover. We will not have a button */
    if (this._getImageElt() && this._imageHoverClass) {
        var $parent = this._getImageElt().parent();
        var $hoverOverlay = $(el8.template.uiwidget.FileUploader.hoverOverlay({
            overlayClass: this._imageHoverClass
        }));
        $parent.before($hoverOverlay);
    }

};


/* Private functions */

el8.uiwidget.FileUploader.prototype._getImageElt = function() {
    return this._isImageUpload ? $('img', this._container) : null;
};

el8.uiwidget.FileUploader.prototype._bindEvents = function() {
    if (this._eventsBound) { return; }

    //Listener to upload files from the form
    this._container.on('change', 'input[type="file"]',  this._inputChangeHandler);

    if (this._droppableArea) {
        //Listener to show/hide the droppable overlay
        $(document).on('dragover', this._dragoverSelector, this._dragoverHandler);

        //Drop listener on the droppable overlay
        var overlaySelector = '.shade-overlay';
        this._container.on('drop', overlaySelector, this._dropHandler);

        /* Default behavior is for elements of the page to not support drag & drop, so
           we have to override this event for any area we want a drop listener on */
        this._container.on('dragover', overlaySelector, function(evt) { evt.preventDefault(); });

        //Prevent stray drops from opening the file in the browser and closing the page
        $(document).on('drop', 'body',  function(evt) { evt.preventDefault(); });
    }
    this._eventsBound = true;
};

el8.uiwidget.FileUploader.prototype._unbindEvents = function() {
    if (!this._eventsBound) { return; }

    this._container.off('change', 'input[type="file"]', this._inputChangeHandler);
    if (this._droppableArea) {
        $(document).off('dragover', this._dragoverSelector, this._dragoverHandler);

        var overlaySelector = '.shade-overlay';
        this._container.off('drop', overlaySelector, this._dropHandler);
        this._container.off('dragover', overlaySelector);

        $(document).off('drop', 'body');
    }

    this._eventsBound = false;
};

el8.uiwidget.FileUploader.prototype._doUpload = function(files) {

    if (!files) { return; }
    if (this._preUploadFn) {
        this._preUploadFn(files);
    }
    var numFiles = files.length;
    var MAX_FILES = 100;
    if (numFiles > MAX_FILES) {
        el8.uiwidget.alert("Sorry, you cannot upload more than " +  MAX_FILES + " at once.");
        this.resetUploadForm();
        return;
    }
    if (!numFiles) {
        this.resetUploadForm();
        return;
    }
    //TODO? max allowable file size

    if (this._onUploadMessage) {
        el8.appservice.notifier.notify(this._onUploadMessage);
    }
    if (this._onUploadFn) { this._onUploadFn(); }

    if (this._customUploadFn) {
        this._customUploadFn(files);
        return;
    }

    var Q = new el8.model.AjaxQueue();

    var that = this;
    for (var i=0; i < numFiles; i++) {

        var $uploadEntry, $progressBar;
        if (this._queueArea) {
            //Add an 'uploading' entry to the file queue
            $uploadEntry = $(el8.template.uiwidget.FileUploader.uploadFileEntry({
                originalFilename: files[i].name,
                processState: 'uploading'
            }));
            this._queueArea.append($uploadEntry);
            $progressBar = $('.progress-indicator', $uploadEntry);
        }

        //Setup for the AJAX request
        var ajaxSuccessFn = (function() {
            var $closuredUploadEntry = $uploadEntry;
            return function(response) {
                if (that._successFn) { that._successFn(response, $closuredUploadEntry); }
                that.resetUploadForm();
            };
        })();
        var ajaxErrorFn = (function() {
            var $closuredUploadEntry = $uploadEntry;
            return function(response) {
                that.resetUploadForm();
                if (that._errorFn) { that._errorFn(response, $closuredUploadEntry); }
            };
        })();
        var updateProgressBar = (function() {
            var $closuredProgressBar = $progressBar;
            return function(evt) {
                if ($closuredProgressBar && evt.lengthComputable) {
                    var percentProgress = Math.floor(evt.loaded / evt.total * 100);
                    $closuredProgressBar.html(percentProgress + "%");
                }
            };
        })();
        var fd = new FormData();
        fd.append('image', files[i]);

        //Construct the AJAX request for each file, including a callback for the progressbar
        var ajaxRequest = {
            type: 'POST',
            url: $.isFunction(that._url) ? that._url() : that._url,
            data: fd,
            contentType: false,
            processData: false,
            success: ajaxSuccessFn,
            error: ajaxErrorFn,
            xhr: function() {
                var xhr = $.ajaxSettings.xhr();
                xhr.upload.onprogress = updateProgressBar;
                return xhr;
            }
        };

        //Queue all the requests in an AjaxQueue, so they don't all send at once
        if (i < numFiles - 1) {
            Q.doAjax(ajaxRequest);
        } else {
            Q.doFinalAjax(ajaxRequest);
        }
    }
};
